export default {
    open: "Odpovězte hned",
    approve: "Schválit nyní",
    impersonation: {
        title: "Objednáváte jménem «{name}»",
        cta: "Přepnout zpět k sobě",
    },
    "You have an unapproved orders": "Máte objednávky ke schválení",
    "You have orders to approve": "Máte objednávky ke schválení"
}